import * as React from 'react'

import { PendingResponse } from 'embed/constants'
import { Product } from 'even-ts-static'

import Spinner from '../Spinner'
import PendingOriginatorImage from './PendingOriginatorImage'

const styles = require('./styles')

export interface Props {
  pendingOriginators: PendingResponse[]
  product: Product
}

// Amount of time before showing the next pending originator logo
const LOADING_TIME = 2 * 1000

export const PendingOriginators: React.FC<Props> = ({ product, pendingOriginators }) => {
  const [selectedOriginatorIndex, setSelectedOriginatorIndex] = React.useState<number>(0)
  const [initialPendingOriginators, setInitialPendingOriginators] = React.useState<PendingResponse[]>()
  let timeout: NodeJS.Timeout

  const incrementSelectedOriginator = React.useCallback(() => {
    timeout = setTimeout(() => {
      setSelectedOriginatorIndex(selectedOriginatorIndex + 1)

      incrementSelectedOriginator()
    }, LOADING_TIME)
  }, [])

  React.useEffect(() => {
    // Filter out the 'Pick a Lender' originator
    setInitialPendingOriginators(
      pendingOriginators.filter(
        (originator) =>
          originator.partner.uuid !== '75988c96-8b7d-4603-b2a4-7ac40e8b41b2' &&
          originator.partner.uuid !== '33d399a4-33c1-4685-ad54-42dd07865a1c',
      ),
    )

    incrementSelectedOriginator()
    return () => {
      clearTimeout(timeout)
    }
  }, [])

  // Select the next originator, if there are no more, go back to the beginning of the list
  const limitedSelectedIndex = selectedOriginatorIndex % (initialPendingOriginators?.length || 1)
  const imageUrl = initialPendingOriginators?.[limitedSelectedIndex]?.partner?.imageUrl

  // We're setting the key to the selectedOriginatorIndex which increments every few seconds to ensure the
  // underlying <div> is re-rendered causing the loading animation to start over
  return product === 'life_insurance' ? (
    <div className={styles.loaderContainer}>
      <Spinner className={styles.spinnerLifeInsurance} />
      <img src={imageUrl} key={selectedOriginatorIndex} />
    </div>
  ) : (
    <PendingOriginatorImage key={selectedOriginatorIndex} imageUrl={imageUrl} />
  )
}
